import { getContext, getElement, store } from "@wordpress/interactivity";

const { actions } = store("wpb", {
	actions: {
		toggle: () => {
			const context = getContext();
			const { ref } = getElement();

			if (!context.multiple) {
				if (!context[ref.id]) {
					// First, close all accordion items by setting their state to false
					actions.closeAll();

					// Then, set the state of the clicked accordion item to true, opening it
					context[ref.id] = true;
				} else {
					// If the clicked accordion item is already open, close it
					context[ref.id] = false;
				}
			} else {
				// If the accordion allows multiple items to be open at the same time, toggle the state of the clicked accordion item
				context[ref.id] = !context[ref.id];
			}
		},
		closeAll: () => {
			const context = getContext();

			// Close all accordion items by setting their state to false
			Object.keys(context).forEach((item) => (context[item] = false));
		},
	},
	callbacks: {
		openFirst: () => {
			const context = getContext();

			if (context.openFirst) {
				context["wp0"] = true;
			}
		},
	},
});
